import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0071d404"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3",
  style: {"max-width":"1000px"}
}
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end ms-auto col-12 mt-xl-4 mt-lg-0 mt-md-0 mt-sm-2 mt-xs-2 mt-2" }
const _hoisted_5 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_9 = { class: "mx-3 m-sm-0" }
const _hoisted_10 = { class: "mx-3 m-sm-0" }
const _hoisted_11 = { class: "mx-3 m-sm-0" }
const _hoisted_12 = { class: "mx-3 m-sm-0" }
const _hoisted_13 = { class: "mx-3 m-sm-0" }
const _hoisted_14 = { class: "mx-3 m-sm-0" }
const _hoisted_15 = { class: "mb-5" }
const _hoisted_16 = { class: "d-flex flex-column justify-content-start align-items-start mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100 my-0" }, null, -1))
const _hoisted_18 = { class: "mx-3 m-sm-0" }
const _hoisted_19 = { class: "mx-3 m-sm-0" }
const _hoisted_20 = { class: "mx-3 m-sm-0" }
const _hoisted_21 = { class: "mx-3 m-sm-0" }
const _hoisted_22 = { class: "mx-1" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-end ms-auto col-12 mt-xl-4 mt-lg-0 mt-md-0 mt-sm-2 mt-xs-2 mt-2" }
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_KaizenItemSearch = _resolveComponent("KaizenItemSearch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ProjectSearch = _resolveComponent("ProjectSearch")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("create_kaizen_strategy")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "success",
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCopyBtnClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("copy")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClearFormClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_form, {
        "label-position": "right",
        "label-width": _ctx.formLabelWidth
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              size: _ctx.formItemSize,
              label: _ctx.t('form.label.creator')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.userInfoStore.displayName), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              size: _ctx.formItemSize,
              label: _ctx.t('form.label.createDate')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.today), 1)
              ]),
              _: 1
            }, 8, ["size", "label"])
          ])
        ]),
        _: 1
      }, 8, ["label-width"]),
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
        ref: "newKaizenFormRef",
        model: _ctx.addForm,
        rules: _ctx.newKaizenFormRules,
        "label-position": _ctx.formLabelPosition,
        "label-width": _ctx.formLabelWidth
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t("project")), 1),
              _hoisted_8
            ]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "projectCode",
              label: _ctx.t('form.label.project_code')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"250px"},
                  modelValue: _ctx.addForm.projectCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addForm.projectCode) = $event)),
                  formatter: (value) => { return value.pjCode},
                  clearable: "",
                  readonly: "",
                  onClick: _ctx.onPJCodeInputFieldClicked,
                  placeholder: _ctx.t('placeholder.input')
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _ctx.Search,
                      onClick: _ctx.onSearchProjectBtnClicked
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "formatter", "onClick", "placeholder"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "periodNum",
              label: _ctx.t('form.label.period')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.addForm.project?.periodNum), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "site",
              label: _ctx.t('form.label.site')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.addForm.project?.siteName), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "factory",
              label: _ctx.t('form.label.factory')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.addForm.project?.factoryName), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "team",
              label: _ctx.t('form.label.team')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.addForm.project?.teamNum), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "startMonth",
              label: _ctx.t('form.label.start_month')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.addForm.project?.startMonth), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "endMonth",
              label: _ctx.t('form.label.end_month')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.addForm.project?.endMonth), 1)
              ]),
              _: 1
            }, 8, ["size", "label"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t("process_part_no")), 1),
              _hoisted_17
            ]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "apsPNInfo",
              label: _ctx.t('form.label.Kaizen_PN')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  disabled: _ctx.addForm.project !== undefined,
                  effect: "light",
                  placement: "bottom",
                  content: _ctx.t('please_select_project_first')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "mx-3 m-sm-0",
                      style: {"width":"250px"},
                      modelValue: _ctx.addForm.apsPNInfo,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addForm.apsPNInfo) = $event)),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      "default-first-option": "",
                      disabled: _ctx.addForm.project === undefined,
                      placeholder: _ctx.t('placeholder.input'),
                      "remote-method": _ctx.onPNSuggestionListShown,
                      loading: _ctx.isPNListLoading,
                      "value-key": "pn",
                      onChange: _ctx.onPNSelectChanged
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidatePN, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.pn,
                            label: item.pn,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "placeholder", "remote-method", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["disabled", "content"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "workNum",
              label: _ctx.t('form.label.work_number')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  disabled: _ctx.addForm.project !== undefined,
                  effect: "light",
                  placement: "bottom",
                  content: _ctx.t('please_select_project_first')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "mx-3 m-sm-0",
                      style: {"width":"250px"},
                      modelValue: _ctx.addForm.apsRoutingInfo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addForm.apsRoutingInfo) = $event)),
                      disabled: _ctx.addForm.project === undefined,
                      "value-key": "workNum",
                      onChange: _ctx.onWorkNumSelectChanged,
                      placeholder: _ctx.t('placeholder.select')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addForm.apsPNInfo?.routings, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.workNum,
                            label: `${item.workNum} (${item.workRemark})`,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "onChange", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["disabled", "content"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "bu",
              label: _ctx.t('form.label.BU')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.addForm.apsPNInfo?.bu), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "endCustomer",
              label: _ctx.t('form.label.endCustomer')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.addForm.apsPNInfo?.custName), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "workRemark",
              label: _ctx.t('form.label.work_remark')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.addForm.apsRoutingInfo?.workRemark), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "manufMethod",
              label: _ctx.t('form.label.manufacture_method')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"150px"},
                  modelValue: _ctx.addForm.manufMethod,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addForm.manufMethod) = $event)),
                  loading: _ctx.isManufMethodListLoading,
                  "value-key": "id",
                  onVisibleChange: _ctx.onManufMethodListShown,
                  onChange: _ctx.onManufMethodSelectChanged,
                  placeholder: _ctx.t('placeholder.select'),
                  "loading-text": _ctx.t('loading')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allManufMethodList, (manufMethod) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: manufMethod.id,
                        label: manufMethod.methodName,
                        value: manufMethod
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading", "onVisibleChange", "onChange", "placeholder", "loading-text"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "implementDay",
              label: _ctx.t('form.label.hoursAdjustmentDate')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"150px"},
                  modelValue: _ctx.addForm.implementDay,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addForm.implementDay) = $event)),
                  type: "date",
                  prop: "implementDay",
                  "value-format": "YYYY-MM-DD",
                  clearable: false,
                  placeholder: _ctx.t('placeholder.date')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "impPlan",
              label: _ctx.t('form.label.improvement_type')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"350px"},
                  modelValue: _ctx.addForm.impPlan,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addForm.impPlan) = $event)),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "impMethod",
              label: _ctx.t('form.label.improvement_suggestions')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"350px"},
                  modelValue: _ctx.addForm.impMethod,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addForm.impMethod) = $event)),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "impMethodDetail",
              label: _ctx.t('form.label.implement_detail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"350px"},
                  modelValue: _ctx.addForm.impMethodDetail,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addForm.impMethodDetail) = $event)),
                  autosize: { minRows: 5 },
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "procTimeBeforeImp",
              label: _ctx.t('form.label.proc_time_before_improvement')
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.addForm.apsRoutingInfo?.stdTime), 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "procTimeAfterImp",
              label: _ctx.t('form.label.proc_time_after_improvement')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  class: "mx-3 m-sm-0 number_input_box",
                  modelValue: _ctx.addForm.procTimeAfterImp,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addForm.procTimeAfterImp) = $event)),
                  precision: 1,
                  step: 0.1,
                  min: 0.0,
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "step", "min", "placeholder"]),
                _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(_ctx.t("second")) + ")", 1)
              ]),
              _: 1
            }, 8, ["size", "label"]),
            _createVNode(_component_el_form_item, {
              class: "mb-4",
              size: _ctx.formItemSize,
              prop: "hyperLink",
              label: _ctx.t('form.label.hyperLink')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mx-3 m-sm-0",
                  style: {"width":"350px"},
                  modelValue: _ctx.addForm.hyperLink,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.addForm.hyperLink) = $event)),
                  clearable: "",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_component_el_image, {
                  class: "sharepoint-icon mx-2",
                  src: require('@/assets/sharepoint_2019.svg'),
                  fit: 'cover',
                  onClick: _ctx.onSharepointClicked
                }, null, 8, ["src", "onClick"])
              ]),
              _: 1
            }, 8, ["size", "label"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSubmitFormClicked()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("submit")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "label-position", "label-width"])), [
        [
          _directive_loading,
          _ctx.isFormLoading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "kaizen-list-dialog",
      modelValue: _ctx.isShowKaizenItemSearchDialog,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isShowKaizenItemSearchDialog) = $event)),
      top: '5vh',
      title: _ctx.t('copy')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isShowKaizenItemSearchDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSelectKaizenItemConfirmClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_KaizenItemSearch, {
          ref: "kaizenItemSearchRef",
          onKaizenItemSelect: _ctx.onKaizenItemSelected
        }, null, 8, ["onKaizenItemSelect"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "project-list-dialog",
      modelValue: _ctx.isShowProjectSearchDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isShowProjectSearchDialog) = $event)),
      top: '5vh',
      title: _ctx.t('inquire')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isShowProjectSearchDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSelectProjectConfirmClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ProjectSearch, {
          ref: "projectSearchRef",
          onProjectSelect: _ctx.onProjectSelected
        }, null, 8, ["onProjectSelect"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}